import { useGoogleLogin, googleLogout } from "@react-oauth/google";
import { useEffect, useState } from "react";
import KakaoLogin from "react-kakao-login";
import { Link, createSearchParams, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { AuthApi, AuthType } from "../../api/Auth.api";
import { UserApi } from "../../api/User.api";
import { ERROR_TYPE } from "../../commons/Const";
import Error from "../../models/Error.model";
import { useAppDispatch, useAppSelector } from "../../store";
import { setUser } from "../../store/modules/app";
import { Container } from "./style";
import { Storage } from "../../utils/Storage";


const { naver } = window

export default function SignInPage() {

  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  const dispatch = useAppDispatch()
  const user = useAppSelector(state => state.app.user)

  const login = useGoogleLogin({
    onSuccess: tokenResponse => {
      getSocialInfo('google', tokenResponse.access_token)
    },
  });

  const [uid, setUid] = useState('')
  const [password, setPassword] = useState('')

  const initializeNaverLogin = () => {
    const naverLogin = new naver.LoginWithNaverId({
      clientId: process.env.REACT_APP_NAVER_CLIENT_ID,
      callbackUrl: process.env.REACT_APP_NAVER_REDIRECT,
      isPopup: true, // popup 형식으로 띄울것인지 설정
      loginButton: { color: 'white', type: 1, height: '47' }, //버튼의 스타일, 타입, 크기를 지정
    });
    naverLogin.init();
  };
    
  useEffect(() => {
    initializeNaverLogin();

    window.addEventListener('message', receiveMessage, false)

    return () => {
      window.removeEventListener('message', receiveMessage, false) 
    }
  }, []);
  
  useEffect(() => {

    
    if(user === undefined) return;

    if(user === null) return;

    const uuid = searchParams.get('uuid')

    if(uuid === null) navigate({pathname: '/'}, {replace: true});
    else navigate({
      pathname: '/payment',
      search: createSearchParams({
        uuid
      }).toString(),
    })
  }, [user, searchParams])

  useEffect(() => {
    const type = searchParams.get('type')
    const code = searchParams.get('code')

    if(type === null || code === null) return

    setSearchParams({})

  }, [searchParams])

  const receiveMessage = (e: MessageEvent) => {

    const token = e.data.accessToken
    if(token) getSocialInfo('naver', token)
  }

  const getSocialInfo = async (type: AuthType, token: string) => {
    try {
      let result = await AuthApi.getSocialInfo(type, token)

      if(result.uid !== '') signInSocial(type, result.uid)
    } catch (error) {
      //console.log(error)
    }
  }

  const signInSocial = (type: AuthType, uid: string) => {
    AuthApi.signInSocial(type, uid)
    .then(result => {
      Storage.set('token', result.token)
      getUser()
    }).catch(error => {
      if(error instanceof Error) {
        if(error.code === ERROR_TYPE.NOT_EXIST_USER) {
          navigate({pathname: '/signup'}, {state: {type, uid}})
        }
      }
    })
  }

  const signInEmail = () => {
    AuthApi.signInEmail(uid, password)
    .then(result => {
      Storage.set('token', result.token);
      getUser()
    }).catch(error => {
      if(error instanceof Error) {
        if(error.code === ERROR_TYPE.NOT_EXIST_USER || error.code === ERROR_TYPE.INCORRECT_PASSWORD) {
          alert('해당 아이디로 가입되어있지 않거나 비밀번호가 일치하지 않습니다.');
        }
      }
    })
  }

  const getUser = () => {
    UserApi.getMe()
    .then(result => {
      dispatch(setUser(result))
    }).catch(console.error)
  }

  if(user) return <></>

  return (
    <Container className="singin">
      <div className="inner">
        <input type="text" placeholder="ID" className="outlined_gray"
          value={uid}
          onChange={e => setUid(e.target.value)}
          onKeyDown={e => {
            if(e.key === 'Enter') {
              signInEmail()
            }
          }}
        />
        <input type="password" placeholder="Password" className="outlined_gray"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={e => {
            if(e.key === 'Enter') {
              signInEmail()
            }
          }}
        />
        <button className="contained_main"
          onClick={signInEmail}
        ><strong className="fs16">로그인</strong></button>

        <div className="group_link flex jc-c">
          <Link to="/certificate" state={{type: 'findId'}}>아이디 찾기</Link>
          <Link to="/certificate" state={{type: 'resetPassword'}}>비밀번호 재설정</Link>
          <Link to="/signup" state={{type: 'email', uid: undefined}}>회원가입</Link>
        </div>
        
        <hr />

        <KakaoLogin
          token={process.env.REACT_APP_KAKAO_APP_KEY ?? ''}
          onSuccess={response => {
            getSocialInfo('kakao', response.response.access_token)
            //signInSocial('kakao', response.response.access_token)
          }}
          onFail={console.error}
          onLogout={console.info}
          render={({onClick}) => {
            return (
              <button className="sns kakao"
                onClick={() => {
                  // Kakao.Auth.authorize({
                  //   redirectUri: 'http://localhost:3000/signin?type=kakao'
                  // })
                  onClick()
                }}
              >
                <img src="/images/signin_kakao_contained.png" alt="카카오 로그인" />
              </button>
            )
          }}
        />
        {/* <button className="sns kakao"
          onClick={() => {
            Kakao.Auth.authorize({
              redirectUri: 'http://localhost:3000/signin?type=kakao'
            })
          }}
        >
          <img src="/images/signin_kakao_contained.png" alt="카카오 로그인" />
        </button> */}
        <button className="sns naver"
          onClick={() => {
            const div = document.getElementById('naverIdLogin')?.firstChild as HTMLElement
            div.click()
            //document.getElementById('naverIdLogin')?.firstChild
            //naverLogin()
            //navigate({pathname: '/signup'}, {state: {type: 'naver'}})
          }}
        >
          <img src="/images/signin_naver_contained.png" alt="네이버 로그인" />
        </button>
        <button className="sns google"
          onClick={() => login()}
        >
          <img src="/images/signin_google_contained.png" alt="구글 로그인" />
        </button>
      </div>
      <div id="naverIdLogin" style={{display: 'none'}}></div>
    </Container>
  )
}